














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { User } from '../types';

@Component
export default class UserList extends Vue {
  @Prop(Array) public users: User[] | null = null;
}
